module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website.53e713dc.jpg";